{
  "todayButton": "Hoy",
  "nextMonth": "Próximo mes",
  "previousMonth": "Mes anterior",
  "nextYear": "Próximo año",
  "previousYear": "Año anterior",
  "weekdays": [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado"
  ],
  "months": [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ]
}
